import {
  DirectedTripleWithFilters,
  MetaModelTriple,
  Path,
} from '@ardoq/api-types';
import { anyType } from '@ardoq/global-consts';

export const getDefaultWildcardViewpoint = (startType: string): Path[] => [
  [
    {
      direction: 'outgoing',
      sourceType: startType,
      targetType: anyType,
      referenceType: anyType,
    },
  ],
  [
    {
      direction: 'incoming',
      sourceType: anyType,
      targetType: startType,
      referenceType: anyType,
    },
  ],
];

const ALL_WILDCARDS = 1;
const CONCRETE_START_WITH_WILDCARDS = 2;

export const isDefaultWildcardTraversal = (paths: Path[] | null): boolean => {
  if (!paths || paths.length === 0) return false;
  const types = new Set(
    paths.flatMap(path =>
      path.flatMap(({ sourceType, targetType, referenceType }) => [
        sourceType,
        targetType,
        referenceType,
      ])
    )
  );
  return (
    paths.length === 2 &&
    paths[0].length === 1 &&
    paths[1].length === 1 &&
    (types.size === ALL_WILDCARDS ||
      types.size === CONCRETE_START_WITH_WILDCARDS) &&
    types.has(anyType)
  );
};

export const isWildcardTriple = (
  triple: Omit<DirectedTripleWithFilters, 'direction'>
): boolean =>
  triple.referenceType === anyType &&
  (triple.sourceType === anyType || triple.targetType === anyType);

export const isMetamodelWildcardTriple = (triple: MetaModelTriple): boolean =>
  triple.referenceType === anyType &&
  (triple.sourceComponentType === anyType ||
    triple.targetComponentType === anyType);
